import {
  getBlogSettings,
  updateBlogSettings as updateBlogSettingsAmbassador,
} from '@wix/ambassador-blog-settings-v2-blog-settings/http';
import type { BlogSettings } from '@wix/ambassador-blog-settings-v2-blog-settings/types';
import type { EditorAppContext } from '../../types/editor-app-context.type';

export async function updateBlogSettings(
  { flowAPI }: EditorAppContext,
  blogSettings: Omit<BlogSettings, 'revision'>,
) {
  const { httpClient, errorHandler } = flowAPI;
  const { withErrorHandler, getResolvedError } = errorHandler;

  try {
    const response = await withErrorHandler(() => httpClient.request(getBlogSettings({})), {
      errorCodesMap: { applicationError: { UNAUTHENTICATED: false, EXPIRED_INSTANCE: false } },
    });
    const lastRevision = response.data.blogSettings?.revision;

    await withErrorHandler(
      () =>
        httpClient.request(
          updateBlogSettingsAmbassador({
            blogSettings: { revision: lastRevision, ...blogSettings },
          }),
        ),
      {
        errorCodesMap: {},
      },
    );
  } catch (error) {
    getResolvedError(error);
    throw error;
  }
}
